(() => {
  const init = root => {
    if (root.dataset.oaReady) return;
    root.dataset.oaReady = 'true';
    const mainImage = root.querySelector('[data-oa-gallery-main]');
    const photoButtons = [...root.querySelectorAll('[data-oa-photo]')];
    const showPhoto = (url, alt, button) => {
      if (!url || !mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = url;
      mainImage.alt = alt || mainImage.alt;
      photoButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    };
    photoButtons.forEach(button => button.addEventListener('click', () => showPhoto(button.dataset.oaPhoto, button.dataset.oaAlt, button)));
    root.querySelectorAll('[data-oa-variant]').forEach(input => input.addEventListener('change', () => {
      if (!input.checked || input.disabled) return;
      const submit = root.querySelector('button[name="add"]');
      if (submit) submit.disabled = false;
      root.querySelectorAll('[data-oa-price]').forEach(price => {
        if (!price.matches('input')) price.textContent = input.dataset.oaPrice;
      });
      if (input.dataset.oaImage) showPhoto(input.dataset.oaImage, input.dataset.oaColour + ' ' + root.querySelector('h1').textContent);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);
    }));
    root.querySelectorAll('[data-oa-state]').forEach(button => button.addEventListener('click', () => {
      const state = button.dataset.oaState;
      root.dataset.state = state;
      root.querySelectorAll('[data-oa-state]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.querySelector('[data-oa-spring-copy]').hidden = state !== 'spring';
      root.querySelector('[data-oa-air-copy]').hidden = state !== 'air';
    }));
    const purchase = root.querySelector('.oa-coil__purchase');
    const sticky = root.querySelector('[data-oa-sticky]');
    if (sticky && purchase && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, { threshold: 0 }).observe(purchase);
    }
  };
  const start = () => document.querySelectorAll('[data-oa-coil]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
